import { render, staticRenderFns } from "./DownTimeFilterdOnReason.vue?vue&type=template&id=546ac4d4&scoped=true"
import script from "./DownTimeFilterdOnReason.vue?vue&type=script&lang=js"
export * from "./DownTimeFilterdOnReason.vue?vue&type=script&lang=js"
import style0 from "./DownTimeFilterdOnReason.vue?vue&type=style&index=0&id=546ac4d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ac4d4",
  null
  
)

export default component.exports